import { Modal, Button, Form } from "react-bootstrap";
import Tabela from "../../../Misc/Tabela/Tabela";
import { usePAChecklist } from "../pa_checklist_context";
import MaterialIcon from 'material-icons-react';
import Select from 'react-select';
import styles from '../pa_checklist.module.scss'
import { isNullish } from "../../../../utils/misc_utils";
import ChecklistRadio from "./pa_checklist_radio";
import { useEffect, useState } from "react";
import ImageCompAnalise from "./pa_checklist_comp_imagens_analise";

const PARevisaoGrade = () => {
  const { modalAnalise, setModalDirecionamento, referenciaSelecionada, direcionamentoChecklist, toggleSemDefeitos, handleRemoverDirecionamento, checarSePossuiDefeitos, quantidadeTotalDirecionada, setModalCancelamento, setIdsCancelamento, abrirModalProcessamento, resultadoCaixa, setModalMedidas, abrirModalInformacoes, combinacoesImagens, setCombinacoesImagens, formularioAnalise, setFormularioAnalise, precoTagDivergente, setPrecoTagDivergente, composicaoTagDivergente, setComposicaoTagDivergente, listaDefeitosComp, gradeRomaneio, listaRomaneioMedidas, localizacaoPilotoAnalise, setPossuiPecaPiloto, possuiPecaPiloto, imagensExtras, setImagensExtras } = usePAChecklist();

  const [qtdePecasAmostra] = useState(gradeRomaneio.reduce((sum, item) => sum + (item.quantidade_total || 0), 0));

  const grade_columns = [
    {
      cell: row => {
        const possuiDefeitos = checarSePossuiDefeitos(row.index_grade);
        return (
          <Button
            variant={possuiDefeitos ? 'danger' : row.sem_defeitos ? 'success' : 'outline-primary'}
            onClick={() => toggleSemDefeitos(row.index_grade)}
            disabled={possuiDefeitos}
          >
            {possuiDefeitos ? 'Defeitos Encontrados' : row.sem_defeitos ? 'Sem Defeitos' : 'Confirmar Sem Defeitos'}
          </Button>
        )
      }, width: '200px'
    },
    { name: 'Tamanho', selector: row => row.tamanho },
    { name: 'Quantidade Total', selector: row => row.quantidade_total },
    { name: 'Quantidade Direcionada', selector: row => row.quantidade_defeituosa },
  ];

  const grade_columns_conditional = [
    {
      when: row => checarSePossuiDefeitos(row.index_grade),
      style: row => ({ backgroundColor: row.index_grade % 2 === 0 ? '#FFCCCC80' : '#FFCCCC50' })
    },
    {
      when: row => !checarSePossuiDefeitos(row.index_grade) && row.sem_defeitos,
      style: row => ({ backgroundColor: row.index_grade % 2 === 0 ? '#CCFFDA80' : '#CCFFDA50' })
    }
  ];

  const direcionamento_columns = [
    {
      cell: (row, index) => {
        return (
          <div onClick={() => handleRemoverDirecionamento(row, index)}>
            <MaterialIcon icon="delete" size={20} color='#BB271A' />
          </div>
        )
      }, width: '60px'
    },
    { name: 'Tamanho', selector: row => row.grade.tamanho, width: '100px' },
    { name: 'Quantidade', selector: row => row.quantidade, width: '100px' },
    { name: 'Status', selector: row => row.status_defeito.label, width: '160px' },
    { name: 'Defeitos', selector: row => row.defeitos.map(item => item.label).join(' | ') },
    { name: 'Loc. Defeito', selector: row => row.localizacao_defeito.map(item => item.label).join(' | ') },
    {
      name: 'Direcionamento',
      selector: row => {
        return resultadoCaixa.length > 0 ? '41 - CHECKLIST + DEVOLUÇÃO' : row.direcionamento.label
      }
    }
  ];

  const handleValueMask = (value) => {
    value = value ? value.replace(/[^0-9]/g, '') : '0';
    const formattedValue = (parseFloat(value) / 100).toFixed(2);
    setPrecoTagDivergente({ key: true, value: formattedValue });
  }

  const handleFileChange = (event, index) => {
    const file = event.target.files[0];
    if (file) {
      combinacoesImagens[index].imagem = file;
      setCombinacoesImagens([...combinacoesImagens]);
    }
  }

  const removerImagem = (index) => {
    combinacoesImagens[index].imagem = null;
    setCombinacoesImagens([...combinacoesImagens]);
  }

  const handleFileChangeOpt = (event, index) => {
    const file = event.target.files[0];
    if (file) {
      imagensExtras[index].imagem = file;
      setImagensExtras([...imagensExtras]);
    }
  }

  const removerImagemOpt = (index) => {
    imagensExtras[index].imagem = null;
    setImagensExtras([...imagensExtras]);
  }

  const removerImagemPermanenteOpt = (index) => {
    const novasImagens = imagensExtras.filter((_, i) => i !== index);
    setImagensExtras(novasImagens);
  }

  const customFilter = (option, searchText) => {
    if (!searchText) return true;
    return option.label.toLowerCase().includes(searchText.toLowerCase());
  }

  // -- HOOK PARA ATUALIZAR OS VALORES DE DEFEITOS DE TAG -- //
  useEffect(() => {
    const ptd = resultadoCaixa.preco_tag_divergente;
    const ctd = resultadoCaixa.composicao_tag_divergente;
    if (ptd) setPrecoTagDivergente({ key: true, value: parseFloat(ptd).toFixed(2) });
    const defeitoCompoAtivo = listaDefeitosComp.filter(item => item.value === ctd);
    if (ctd) setComposicaoTagDivergente({ key: true, defeitos: [...defeitoCompoAtivo] });
  }, []);

  // -- HOOK PARA ATUALIZAR O CAMPO DISPENSAR MEDIDAS E GRADAÇÃO -- //
  useEffect(() => {
    const formularioAtualizado = { ...formularioAnalise }
    if (referenciaSelecionada.desenvolvimento_interno) formularioAtualizado.dispensar_medidas = false;
    if (listaRomaneioMedidas.length === 0) formularioAtualizado.dispensar_medidas = true;
    if (gradeRomaneio.length === 1) formularioAtualizado.gradacao = false;
    setFormularioAnalise({ ...formularioAtualizado });
  }, []);

  return (
    <Modal
      show={modalAnalise}
      centered
      fullscreen={true}
    >
      <Modal.Header style={{ fontWeight: '500' }}>
        <div>
          Checklist {referenciaSelecionada.nf_segunda_qualidade ? '(Segunda Qualidade) ' : ''} | NF: {referenciaSelecionada.nf_entrada} | Produto: {referenciaSelecionada.produto} | Cor: {referenciaSelecionada.cor_produto} | Descrição: {referenciaSelecionada.descricao_produto} | Desenvolvimento {referenciaSelecionada.desenvolvimento_interno ? 'Interno' : 'Externo'} | {resultadoCaixa.possui_peca_piloto ? 'Possui Peça Piloto' : 'Sem Peça Piloto'}
        </div>
        <Button
          variant={'danger'}
          className={styles.footer_btn_processamento}
          onClick={() => {
            setModalCancelamento(true);
            setIdsCancelamento([referenciaSelecionada.id_controle]);
          }}
        >
          Cancelar Análise
        </Button>
      </Modal.Header>
      <Modal.Body className={styles.modal_body}>
        <section className={styles.dados_analise_wrapper}>
          <div className={styles.dados_analise_item_duplo}>
            <div>
              <label className={styles.sub_form_label}>Qtde. de peças da produção</label>
              <span className={styles.font_blue_big}>{referenciaSelecionada.qtde_entrada}</span>
            </div>
            <div>
              <label className={styles.sub_form_label}>Qtde. de peças na amostra</label>
              <span className={styles.font_blue_big}>{qtdePecasAmostra}</span>
            </div>
            <div>
              <label className={styles.sub_form_label}>Qtde. de peças direcionadas</label>
              <span className={styles.font_blue_big}>{quantidadeTotalDirecionada}</span>
            </div>
          </div>

          <div
            style={{
              display: referenciaSelecionada.nf_segunda_qualidade || referenciaSelecionada.produto_de_couro ? 'block' : 'none'
            }}
            className={styles.dados_analise_item}
          >
            <label
              style={{ display: referenciaSelecionada.nf_segunda_qualidade ? 'block' : 'none' }}
              className={styles.sub_form_label_warn}
            >
              Esta é uma nota fiscal de segunda qualidade - Portanto todas as peças deverão ser revisadas
            </label>
            <label
              style={{ display: referenciaSelecionada.produto_de_couro ? 'block' : 'none' }}
              className={styles.sub_form_label_warn}
            >
              Esta é uma nota fiscal de couro - Portanto todas as peças deverão ser revisadas
            </label>
          </div>

          <div className={styles.separator}></div>

          <div className={styles.btn_preco_wrapper}>
            <label className={styles.sub_form_label}>
              Preencha o campo abaixo se houver divergência entre os valores da TAG do produto e no LINX
            </label>
            <label className={styles.sub_form_label}>
              <span>Preço LINX - R$ </span><span className={styles.font_blue_big}>{referenciaSelecionada.preco_produto}</span>
            </label>
            {
              resultadoCaixa.preco_tag_divergente &&
              <label className={styles.sub_form_label} style={{ backgroundColor: '#e6410030', padding: '8px 16px', borderRadius: '6px' }}>
                Valor inserido durante conferência de caixa: R$ <span className={styles.font_blue_big}>{parseFloat(resultadoCaixa.preco_tag_divergente).toFixed(2)}</span>
              </label>
            }

            <Form.Group className={styles.dados_analise_divergencias}>
              <Form.Check
                type={'switch'}
                style={{ transform: 'scale(1.8)' }}
                onChange={() => setPrecoTagDivergente({ key: !precoTagDivergente.key, value: '' })}
                checked={precoTagDivergente.key}
                value={precoTagDivergente.key}
              />
              <Form.Control
                type={'text'}
                placeholder={'Preço Divergente TAG'}
                value={precoTagDivergente.value}
                onChange={e => handleValueMask(e.target.value)}
                style={{ minWidth: '150px', height: '38px', width: '33%' }}
                disabled={!precoTagDivergente.key}
                isInvalid={
                  parseFloat(precoTagDivergente.value) === parseFloat(referenciaSelecionada.preco_produto)
                  || (precoTagDivergente.key && isNullish(precoTagDivergente.value))
                }
              />
            </Form.Group>
          </div>

          <div className={styles.separator}></div>

          <div className={styles.btn_preco_wrapper}>
            <label className={styles.sub_form_label}>
              Preencha o campo abaixo se houver divergência entre as composições na TAG do produto e no LINX
            </label>
            <label className={styles.sub_form_label}>
              Composição LINX - <span className={styles.font_blue_big}>{referenciaSelecionada.composicao}</span>
            </label>
            {
              resultadoCaixa.composicao_tag_divergente &&
              <label
                className={styles.sub_form_label}
                style={{ backgroundColor: '#e6410030', padding: '8px 16px', borderRadius: '6px', textAlign: 'center' }}
              >
                Defeito inserido durante conferência de caixa:<br />
                <span className={styles.font_blue_big} style={{ fontSize: '12px' }}>
                  {listaDefeitosComp.filter(item => item.value === resultadoCaixa.composicao_tag_divergente)[0].label}
                </span>
              </label>
            }

            <Form.Group className={styles.dados_analise_divergencias}>
              <Form.Check
                type={'switch'}
                style={{ transform: 'scale(1.8)', alignSelf: 'center' }}
                onChange={() => setComposicaoTagDivergente({
                  key: !composicaoTagDivergente.key,
                  defeitos: []
                })}
                value={composicaoTagDivergente.key}
                checked={composicaoTagDivergente.key}
              />

              <Select
                className={styles.select_comp}
                placeholder={'Defeitos Comp.'}
                value={composicaoTagDivergente.defeitos}
                onChange={e => setComposicaoTagDivergente({
                  key: true,
                  defeitos: [e]
                })}
                options={listaDefeitosComp}
                filterOption={customFilter}
                isDisabled={!composicaoTagDivergente.key}
                styles={{
                  control: base => ({
                    ...base,
                    borderColor: composicaoTagDivergente.key && composicaoTagDivergente.defeitos.length === 0 ? 'red' : base.borderColor,
                    '&:hover': {
                      borderColor: composicaoTagDivergente.key && composicaoTagDivergente.defeitos.length === 0 ? 'red' : base['&:hover'].borderColor
                    }
                  })
                }}
              />
            </Form.Group>
          </div>

          <div className={styles.separator} />

          <div>
            <div className={styles.btn_preco_wrapper}>
              <label className={styles.sub_form_label} style={{ marginBottom: '16px' }}>Pontos Críticos de Inspeção</label>
            </div>
            <div>
              <ChecklistRadio
                title={'Gradação realizada'}
                name={'gradacao'}
                idTrue={'gradacao_true'}
                idFalse={'gradacao_false'}
                labelTrue={'Sim'}
                labelFalse={'Não'}
                checked={formularioAnalise.gradacao}
                onChangeTrue={() => setFormularioAnalise({ ...formularioAnalise, gradacao: true })}
                onChangeFalse={() => setFormularioAnalise({ ...formularioAnalise, gradacao: false })}
                disabled={gradeRomaneio.length === 1}
              />
              <div
                style={{ display: formularioAnalise.gradacao === false && gradeRomaneio.length > 1 ? 'block' : 'none' }}
                className={styles.crazy_warn}
              >
                Atenção, colaborador(a)! Gradação é obrigatória toda vez que são recebidos mais de um tamanho entre as amostras, somente em casos específicos ela é dispensada. Portanto, antes de dispensar e/ou em caso de dúvidas, entre em contato com o/a analista responsável.
              </div>
              <ChecklistRadio
                title={'Zíper invisível detectado'}
                name={'ziper_inv'}
                idTrue={'ziper_inv_true'}
                idFalse={'ziper_inv_false'}
                labelTrue={'Sim'}
                labelFalse={'Não'}
                checked={formularioAnalise.ziper}
                onChangeTrue={() => setFormularioAnalise({ ...formularioAnalise, ziper: true })}
                onChangeFalse={() => setFormularioAnalise({ ...formularioAnalise, ziper: false })}
              />
              <div style={{ display: formularioAnalise.ziper ? 'block' : 'none' }} className={styles.crazy_warn}>
                Atenção, colaborador(a)! A trava de zíper dessa amostra deve ser verificada obrigatoriamente. Em caso de dúvidas, entre em contato com o/a analista responsável.
              </div>
              <ChecklistRadio
                title={'Costura com fio detectado'}
                name={'fio_detectado'}
                idTrue={'fio_detectado_true'}
                idFalse={'fio_detectado_false'}
                labelTrue={'Sim'}
                labelFalse={'Não'}
                checked={formularioAnalise.fio_detectado}
                onChangeTrue={() => setFormularioAnalise({ ...formularioAnalise, fio_detectado: true })}
                onChangeFalse={() => setFormularioAnalise({ ...formularioAnalise, fio_detectado: false })}
              />
              <div style={{ display: formularioAnalise.fio_detectado ? 'block' : 'none' }} className={styles.crazy_warn}>
                Atenção, colaborador(a)! Este é um defeito grave e passível de desconto. Portanto, deve ser obrigatoriamente mencionado no Direcionamento. Em caso de dúvidas, entre em contato com o/a analista responsável.
              </div>
              <ChecklistRadio
                title={'Dispensar medidas?'}
                name={'dispensar_medidas'}
                idTrue={'dispensar_medidas_true'}
                idFalse={'dispensar_medidas_false'}
                labelTrue={'Sim'}
                labelFalse={'Não'}
                checked={formularioAnalise.dispensar_medidas}
                onChangeTrue={() => setFormularioAnalise({ ...formularioAnalise, dispensar_medidas: true })}
                onChangeFalse={() => setFormularioAnalise({ ...formularioAnalise, dispensar_medidas: false })}
                disabled={referenciaSelecionada.desenvolvimento_interno || listaRomaneioMedidas.length === 0}
              />

              <div style={{ display: (formularioAnalise.dispensar_medidas && listaRomaneioMedidas.length > 0) ? 'block' : 'none' }} className={styles.crazy_warn}>
                Atenção, colaborador(a)! A dispensa deve ser usada exclusivamente para produtos específicos do qual não medimos. Em caso de dúvidas, entre em contato com o/a analista responsável.
              </div>

              <div style={{ display: listaRomaneioMedidas.length === 0 ? 'block' : 'none' }} className={styles.crazy_warn}>
                Não há nenhum tamanho padrão para ser medido na grade do produto - portanto ele está automaticamente dispensado.
              </div>

              <ChecklistRadio
                title={'Possui Peça Piloto?'}
                name={'possui_peca_piloto'}
                idTrue={'possui_peca_piloto_true'}
                idFalse={'possui_peca_piloto_false'}
                labelTrue={'Sim'}
                labelFalse={'Não'}
                checked={possuiPecaPiloto}
                onChangeTrue={() => setPossuiPecaPiloto(true)}
                onChangeFalse={() => setPossuiPecaPiloto(false)}
              />

              <div className={styles.separator} style={{ margin: '10px 0px' }} />

              <div>
                <label className={styles.sub_form_label} style={{ marginBottom: '16px', textAlign: 'center' }}>Localização Peça Piloto</label>
                {
                  localizacaoPilotoAnalise.length === 0 &&
                  <div style={{ fontWeight: '500', textAlign: 'center' }}>
                    Não há dados de localização da piloto no momento
                  </div>
                }
                {
                  localizacaoPilotoAnalise.length > 0 &&
                  localizacaoPilotoAnalise.map((item, index) => {
                    return (
                      <span key={`loc_p_p_${index}`}>
                        <span style={{ fontWeight: '500' }}>{item.localizacao} |</span>&nbsp;
                        <span style={{ fontWeight: '500' }}>{item.estoque} | Produto tal qual:</span>&nbsp;
                        <span style={{ fontWeight: '500' }}>{item.produto_tq || '-'}</span>
                      </span>
                    );
                  })}
              </div>
            </div>
          </div>

          <div className={styles.separator} />

          <div className={styles.btn_preco_wrapper}>
            <label className={styles.sub_form_label}>Imagens de Defeitos</label>
          </div>
          <div style={{ display: "flex", flexWrap: "wrap", justifyContent: 'left', columnGap: '0.5%', rowGap: '10px' }}>
            {combinacoesImagens.length === 0 && (
              <label
                style={{ margin: 'auto', backgroundColor: '#B4E380', padding: '8px 16px', borderRadius: '10px' }}
                className={styles.sub_form_label}
              >
                Não é necessário inserir imagens quando não há defeitos na produção.
              </label>
            )}

            {
              combinacoesImagens.map((item, index) => {
                const combinationValues = Object.values(JSON.parse(item.combination));
                return (
                  <ImageCompAnalise
                    key={`imagem_modal_${index}`}
                    item={item}
                    index={index}
                    onFileChange={handleFileChange}
                    onRemove={removerImagem}
                    type="default"
                    combinationValues={combinationValues}
                  />
                );
              })
            }
          </div>

          <div className={styles.separator} />

          <div
            style={{
              display: 'flex', width: '100%', justifyContent: 'center', gap: '16px', alignItems: 'center'
            }}
          >
            <label className={styles.sub_form_label}>Imagens Opcionais</label>
            <span
              style={{ backgroundColor: '#0D6EFD30', padding: '4px 6px', borderRadius: '4px', cursor: 'pointer', fontWeight: '500' }}
              onClick={() => {
                imagensExtras.push({ combination: 'opt', imagem: null });
                setImagensExtras([...imagensExtras]);
              }}
            >
              Adicionar Imagem
            </span>
          </div>

          {imagensExtras.length === 0 && (
            <label
              style={{ margin: 'auto', backgroundColor: '#B4E380', padding: '8px 16px', borderRadius: '10px' }}
              className={styles.sub_form_label}
            >
              Nenhuma imagem extra inserida.
            </label>
          )}

          {
            imagensExtras.length > 0 &&
            <div style={{ display: "flex", flexWrap: "wrap", justifyContent: 'left', columnGap: '0.5%', rowGap: '10px' }}>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: 'left',
                  columnGap: '0.5%',
                  rowGap: '10px',
                  width: '100%'
                }}
              >
                {
                  imagensExtras.map((item, index) => {
                    return (
                      <ImageCompAnalise
                        key={`imagem_modal_opt_${index}`}
                        item={item}
                        index={index}
                        onFileChange={handleFileChangeOpt}
                        onRemove={removerImagemOpt}
                        type="optional"
                        combinationValues={[]}
                        onRemovePermanent={removerImagemPermanenteOpt}
                      />
                    );
                  })
                }
              </div>
            </div>
          }
        </section>

        <section>
          <label className={styles.form_label}>Grade</label>
          <Tabela
            columns={grade_columns}
            data={gradeRomaneio}
            pagination={false}
            conditionalRowStyles={grade_columns_conditional}
          />
        </section>

        <section>
          <label className={styles.form_label}>Direcionamento</label>
          <Tabela
            columns={direcionamento_columns}
            data={direcionamentoChecklist}
            pagination={false}
          />
        </section>
      </Modal.Body>
      <Modal.Footer className={styles.modal_footer}>
        <Button
          variant={'warning'}
          className={styles.footer_btn_direcionamento}
          onClick={() => setModalDirecionamento(true)}
        >
          {`Direcionar Peças ${referenciaSelecionada.nf_segunda_qualidade ? '(Segunda Qualidade)' : ''}`}
        </Button>
        <Button
          variant={'warning'}
          className={styles.footer_btn_processamento}
          onClick={() => setModalMedidas(true)}
          disabled={gradeRomaneio.length === 0 || formularioAnalise.dispensar_medidas}
        >
          Medidas
        </Button>
        <Button
          variant={'primary'}
          className={styles.footer_btn_processamento}
          onClick={() => abrirModalInformacoes(referenciaSelecionada)}
        >
          Informações
        </Button>
        <Button
          variant={'success'}
          className={styles.footer_btn_processamento}
          onClick={() => abrirModalProcessamento()}
        >
          Resumo | Processar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default PARevisaoGrade;
